<template>
  <div>
    <Chart :cdata="cdata" :width="style.width" :height="style.height" />
  </div>
</template>

<script>
import Chart from '../chart.vue'
// import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
	  cdata: {
		category: [
		  "1月",
		  "2月",
		  "3月",
		  "4月",
		  "5月",
		  "6月",
		  "7月",
		  "8月",
		  "9月",
		  "10月",
		  "11月",
		  "12月"
		],
		rateData: [],
		id:"operateIncomeChart",
		legendData:[{
			  name:"运营",
			  icon: 'roundRect',
			}, {
			  name:"建设",
			  icon: 'roundRect',
			}
		// 	, {
		// 	  name:"签约",
		// 	  icon: 'roundRect',
		// }
		],
		series:[
			{
			  name: "运营",
			  type: "bar",
			  barWidth: 10,
			  itemStyle: {
				normal: {
				  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
					{ offset: 0, color: "#3FFFE7" },
					{ offset: 1, color: "#60F5FF" }
				  ])
				}
			  },
			  // data: this.operList
			  data: []
			},
			{
			  name: "建设",
			  type: "bar",
			  barWidth: 10,
			  itemStyle: {
				color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
				  { offset: 0, color: "#213EEB" },
				  { offset: 1, color: "#7299FF" }
				])
			  },
			  // data: this.setList
				data: []
			},
			// {
			//   name: "签约",
			//   type: "bar",
			//   barWidth: 10,
			//   itemStyle: {
			// 	color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
			// 	  { offset: 0, color: "#7299FF" },
			// 	  { offset: 1, color: "#213EEB" }
			// 	])
			//   },
			//   // data: this.signedList
			//   data: []
			// },
		]
	  },
	  style:{
		  width: '400',
		  height: '180'
	  }
    };
  },
  components: {
    Chart
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectAddPassFromMonth(data);
			this.selectConstructFromMounth(data);
    },
		selectConstructFromMounth(data={}){
			let _this = this;
				// 建设中
				let params = {};
				if(data){
				//TiDB-省市区-建设中通道数月度趋势图 
				params = {
					"enCode":"TiDB-shengshiqu- jianshezhongtongdaoshuyueduqushitu",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-jianshezhongtongdaoshu"//TiDB-全国-建设中通道数月度趋势图
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
						// "cnt": "0",
            // "month_num": "1"
						let cnt = [];
						cnt = res.map(item=>item.cnt);
						let xList = res.map(item=>item.cur_date);
		  		  this.cdata.series[1].data = cnt;//建设List
          	this.cdata.category = xList;

        })
        .catch((err) => {
          console.log(err);
        });
		},
    selectAddPassFromMonth(data={}){
      let _this = this;
				// 运营中
				let params = {};
				if(data){
				//TiDB-省市区-运营中通道数月度趋势图
				params = {
					"enCode":"TiDB-shengshiqu-yunyingzhongtongdaoshuyueduqushitu",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-yunyingzhongtongdaoshuyuedutu"//TiDB-全国-运营中通道数月度趋势
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
					let cnt = [];
					cnt = res.map(item=>item.cnt);
					let xList = res.map(item=>item.cur_date);
					this.cdata.series[0].data = cnt;//运营List  
          this.cdata.category = xList;

        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>